import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import thunk from 'redux-thunk';

import assets from './reducers/assets';
import auth from './reducers/auth';
import contacts from './reducers/contacts';
import items from './reducers/items';
import itemForm from './reducers/itemForm';
import persistence from './middlewares/persistence';
import contactForm from './reducers/contactForm';
import properties from './reducers/properties';
import Property from './reducers/Property';
import propertyForm from './reducers/propertyForm';
import serviceRequest from './reducers/serviceRequest';
import serviceRequests from './reducers/serviceRequests';
import paginationCount from './reducers/Pagination';
import serviceRequestStatusPageCount from './reducers/ServiceRequestStatusPageCount';
import reports from './reducers/Reports';

import serviceRequestForm from './reducers/serviceRequestForm';
import availableServiceTimes from './reducers/availableServiceTimes';
import suites from './reducers/suites';
import userSuites from './reducers/userSuites';
import typeahead from './reducers/typeahead';
import formOptions from './reducers/formOptions';
import { jwtDecode } from 'jwt-decode';
import suiteForm from './reducers/suiteForm';
import faqsNotesDocuments from './reducers/faqsNotesDocuments';
import fndForm from './reducers/fndForm';
import assetForm from './reducers/assetForm';
import search from './reducers/search';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import Messages from './reducers/Messages';
import settings from './reducers/settings';

import suiteAreas from './reducers/suiteAreas';
import suiteAssetAreas from './reducers/suiteAssetAreas';

import propertyWalkThroughForm from './reducers/propertyWalkThroughForm';
import easyWalkThroughForm from './reducers/easyWalkThroughForm';
import areas from './reducers/areas';
import walkthroughtSuites from './reducers/WalkthroughSuites';
import loader from './reducers/loader';
import validation from './reducers/Validation';
import { getNewAuthorizationToken, setReport } from './actions/auth';
import recentActivity from './reducers/RecentActivity';
import propertyLoader from './reducers/PropertyLoader';
import formLoader from './reducers/FormLoader';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AnnouncementForm from './reducers/AnnouncementForm';
import announcements from './reducers/Announcements';

import walkThrough from './reducers/walkThroughs';

import commonAreas from './reducers/commonAreas';
import propertyCommonAreas from './reducers/propertyCommonAreas';
import suiteUsers from './reducers/suiteUsers';
import OverviewStatus from './reducers/OverviewStatus';
import commonIssues from './reducers/CommonIssues';
import commonAreaAssets from './reducers/commonAreaAssets';
import commonAreaAssetForm from './reducers/commonAreaAssetForm';
import propertyDevelopers from './reducers/propertyDevelopers';
import counts from './reducers/Counts';
import csvExport from './reducers/csvExport';
import PropertyVideos from './reducers/PropertyVideos';
import collapseSideBar from './reducers/collapseSideBar';
import buildings from './reducers/buildings';
import levels from './reducers/levels';
import homeownerOnboardingForm from './reducers/HomeownerOnboardingComponent';
import homeownerOnboarding from './reducers/HomeownerOnboarding';

import suiteStatuses from './reducers/SuiteStatus';
import constructionStages from './reducers/ConstructionStages';
import moreDetails from './reducers/MoreDetails';
import onboardingData from './reducers/HomeOwnerOnboardingDashboard';
import Filter from './reducers/Filter';
import keyContacts from './reducers/KeyContacts';
import FilterServiceProviderandPropertyDeveloperList from './reducers/FilterServiceProviderandPropertyDeveloperList';
import serviceRequestsByGroup from './reducers/serviceRequestsByGroup';
import inbox from './reducers/Inbox';
import responseStore from './reducers/ResponseStore';
import specifications from './reducers/Specifications';
import tabSelections from './reducers/tabSelections';
import FilterCommonAreas from './reducers/FilterCommonAreas';
import keyPickup from './reducers/KeyPickup';
import activeTab from './reducers/activeTab';
import { PATHS } from '../common/constants';
import emailTemplates from './reducers/emailTemplates';
import feedbackReport from './reducers/feedbackReport';
import notes from './reducers/notes';
import serviceRequestStats from './reducers/ServiceRequestStatsReports';
import filters from './reducers/serviceRequestDashboard/filters';

const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const checkTokenExpirationMiddleware = (store) => (next) => (action) => {
  const token = JSON.parse(localStorage.getItem('auth'));
  if (token === null) {
    if (
      window.location.href.includes('auth/') ||
      window.location.origin + '/' === window.location.href
    ) {
    } else {
      if (localStorage.getItem('redirectURL') === null) {
        if (
          window.location.href.includes('app/service-requests') ||
          window.location.href.includes('app/videoChat/chatId=channel')
        ) {
          let url = window.location.href.split(window.location.origin)[1];
          localStorage.setItem('redirectURL', url);
          if (localStorage.getItem('isAnnotationImageUpload') === 'true') {
            localStorage.removeItem('isAnnotationImageUpload');
            toast.error(
              ' 🚫There seems to be some problem with the low memory, unable to process the request now.',
              {
                autoClose: 12000,
                position: 'top-center',
              }
            );
          } else {
            window.location.href = window.location.origin + PATHS.AUTH_SIGN_IN;
          }
        } else {
          if (localStorage.getItem('isAnnotationImageUpload') === 'true') {
            localStorage.removeItem('isAnnotationImageUpload');
            toast.error(
              ' 🚫There seems to be some problem with the low memory, unable to process the request now.',
              {
                autoClose: 12000,
                position: 'top-center',
              }
            );
          } else {
            window.location.href = window.location.origin + PATHS.AUTH_SIGN_IN;
          }
        }
      } else {
        if (localStorage.getItem('isAnnotationImageUpload') === 'true') {
          localStorage.removeItem('isAnnotationImageUpload');
          toast.error(
            ' 🚫There seems to be some problem with the low memory, unable to process the request now.',
            {
              autoClose: 12000,
              position: 'top-center',
            }
          );
        } else {
          window.location.href = window.location.origin + PATHS.AUTH_SIGN_IN;
        }
      }
    }
  } else {
    var tokenDecoded = jwtDecode(token);
    // console.log('this is a jwt token and date time',tokenDecoded&&tokenDecoded.exp,Date.now() / 1000)

    if (tokenDecoded && tokenDecoded.exp) {
      let checkActivityTime = tokenDecoded.exp - 1200;
      if (checkActivityTime <= Date.now() / 1000) {
        let user = JSON.parse(localStorage.getItem('user'));

        if (user && user.id) {
          // alert('test 50 minute time out ')
          getNewAuthorizationToken(user.id);
        }
      }
    }

    if (tokenDecoded && tokenDecoded.exp < Date.now() / 1000) {
      toast.error(' 🚫 Your session has timed out, please login again.', {
        autoClose: 12000,
        position: 'top-center',
      });
      let user = JSON.parse(localStorage.getItem('user'));
      if (user && user.id) {
        let report = {
          UserId: user.id,
          Event: 'Logout',
        };
        setReport(report);
      }

      localStorage.setItem('sessionTimeOut', 'true');
      localStorage.removeItem('redirectURL');
      localStorage.removeItem('userId');
      localStorage.removeItem('auth');
      localStorage.removeItem('user');
      localStorage.removeItem('persist:root');
      if (localStorage.getItem('isAnnotationImageUpload') === 'true') {
        localStorage.removeItem('isAnnotationImageUpload');
        toast.error(
          ' 🚫There seems to be some problem with the low memory, unable to process the request now.',
          {
            autoClose: 12000,
            position: 'top-center',
          }
        );
      } else {
        window.location.href = window.location.origin + PATHS.AUTH_SIGN_IN;
      }
    }
  }
  next(action);
};

const rootReducer = combineReducers({
  assets,
  auth,
  contacts,
  contactForm,
  items,
  itemForm,
  properties,
  Property,
  propertyForm,
  serviceRequest,
  serviceRequests,
  serviceRequestsByGroup,
  serviceRequestForm,
  serviceRequestStats,
  suites,
  userSuites,
  suiteForm,
  typeahead,
  formOptions,
  faqsNotesDocuments,
  fndForm,
  assetForm,
  search,
  availableServiceTimes,
  Messages,
  settings,
  serviceRequestDashboardFilters: filters,

  suiteAreas,
  suiteAssetAreas,

  propertyWalkThroughForm,
  easyWalkThroughForm,
  areas,
  loader,
  walkthroughtSuites,
  validation,
  recentActivity,
  propertyLoader,
  formLoader,
  AnnouncementForm,
  announcements,
  walkThrough,
  commonAreas,
  propertyCommonAreas,
  suiteUsers,
  OverviewStatus,
  commonIssues,
  commonAreaAssets,
  commonAreaAssetForm,
  propertyDevelopers,
  paginationCount,
  serviceRequestStatusPageCount,
  reports,
  counts,
  csvExport,
  PropertyVideos,
  collapseSideBar,
  buildings,
  levels,
  homeownerOnboardingForm,
  homeownerOnboarding,
  suiteStatuses,
  constructionStages,
  moreDetails,
  onboardingData,
  Filter,
  FilterServiceProviderandPropertyDeveloperList,
  keyContacts,
  inbox,
  responseStore,
  specifications,
  tabSelections,
  FilterCommonAreas,
  keyPickup,
  activeTab,
  emailTemplates,
  feedbackReport,
  notes,
});
const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  pReducer,
  {
    auth: JSON.parse(localStorage.getItem('auth')),
  },
  composeEnhancers(
    applyMiddleware(thunk, persistence, checkTokenExpirationMiddleware)
  )
);
export const persistor = persistStore(store);
